export const POLL_RESPONSE_FILTER_ALL = '__all__'

export interface PollResponseReportFilterValues {
  pollId: string
  schoolId: string
  classId: string
  dateFrom: string
  dateTo: string
  questionType: string
  status: string
}

export const EMPTY_POLL_RESPONSE_REPORT_FILTERS: PollResponseReportFilterValues = {
  pollId: POLL_RESPONSE_FILTER_ALL,
  schoolId: POLL_RESPONSE_FILTER_ALL,
  classId: POLL_RESPONSE_FILTER_ALL,
  dateFrom: '',
  dateTo: '',
  questionType: POLL_RESPONSE_FILTER_ALL,
  status: POLL_RESPONSE_FILTER_ALL,
}
